import axios from 'axios';
import { BASE_URL } from '../config/config';

const URL = BASE_URL + '/projects-cost-transactions';

const getPCTransactionList = async (keyword, page, limit) => {
  try {
    const response = await axios.get(URL, {
      params: {
        keyword,
        page,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const deletePCTransaction = async (id) => {
  try {
    await axios.delete(`${URL}/${id}`);
  } catch (error) {
    console.log(error);
  }
};

const createPCTransaction = async (data) => {
  try {
    const result = await axios.post(URL, data);
    console.log(result);
    // console.log(data);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error creating the transactions.');
    }
  }
};

const getPCTransactionById = async (id) => {
  try {
    const response = await axios.get(`${URL}/${id}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const updatePCTransaction = async (id, data) => {
  try {
    // console.log(data);
    await axios.put(`${URL}/${id}`, data);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error updating the project transaction.');
    }
  }
};

export {
  getPCTransactionList,
  deletePCTransaction,
  createPCTransaction,
  getPCTransactionById,
  updatePCTransaction,
};
